import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate" //状态持久化

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    //通过reducer可以传需要保存到localStorage中状态
    //状态持久化
    reducer: (state)=>{
      return{
        isactive_1: state.isactive_1,
        isactive_2: state.isactive_2,
        isactive_3: state.isactive_3,
        isactive_4: state.isactive_4,
        isactive_5: state.isactive_5,
      }
    }
  })],
  state: {
    isactive_1:true,
    isactive_2:false,
    isactive_3:false,
    isactive_4:false,
    isactive_5:false,
    lookmore:false,
    MaterialLevelshow:false,
    pageshow:false,     //控制二维页面是否显示，用于三维页面加载完成
    batchlayout:false  //控制批料排次弹框是否显示
  },
  getters: {
  },
  mutations: {
    changestate_1(state){
      state.isactive_1 = true;
      state.isactive_2 = false;
      state.isactive_3 = false;
      state.isactive_4 = false;
      state.isactive_5 = false;
    },
    changestate_2(state){
      state.isactive_1 = false;
      state.isactive_2 = true;
      state.isactive_3 = false;
      state.isactive_4 = false;
      state.isactive_5 = false;    
    },
    changestate_3(state){
      state.isactive_1 = false;
      state.isactive_2 = false;
      state.isactive_3 = true;
      state.isactive_4 = false;
      state.isactive_5 = false;
    },
    changestate_4(state){
      state.isactive_1 = false;
      state.isactive_2 = false;
      state.isactive_3 = false;
      state.isactive_4 = true;
      state.isactive_5 = false;
    },
    changestate_5(state){
      state.isactive_1 = false;
      state.isactive_2 = false;
      state.isactive_3 = false;
      state.isactive_4 = false;
      state.isactive_5 = true;
    },
    changeLookmore(state){
      state.lookmore = !state.lookmore
    },
    changeLookmore_false(state){
      state.lookmore = false
    },
    changeMaterialLevelshow(state){
      state.MaterialLevelshow = !state.MaterialLevelshow
    },
    MaterialLevelshow_false(state){
      state.MaterialLevelshow = false
    },
    changepageshow(state){
      state.pageshow = true
    },
    changebatchlayout(state){
      state.batchlayout = !state.batchlayout
    },
    changeBatchLayout_false(state){
      state.batchlayout = false
    }
  },
  actions: {
  },
  modules: {
  }
})
